import { call, put, all } from 'redux-saga/effects';
import { map } from 'lodash/fp';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchPosOrderByVisitTrackId as fetchPosOrderByVisitTrackIdRoutine,
  createPosOrder as createPosOrderRoutine,
  completePosOrder as completePosOrderRoutine,
  cancelPosOrder as cancelPosOrderRoutine,
  adjustPosOrder as adjustPosOrderRoutine,
  addPosOrderItem as addPosOrderItemRoutine,
  updatePosOrderItemQuantity as updatePosOrderItemQuantityRoutine,
  deletePosOrderItem as deletePosOrderItemRoutine
} from './routines';
import {
  setFetchPosOrderError,
  removeDeletedPosOrderItem
} from '../../actions/order';
import { clearOrderAdjustment } from '../../actions';
import orderAdjustmentToBodyFormat from '../../../../helpers/pos/orderAdjustmentToBodyFormat';
import redirectToVisitPage from '../../../../helpers/pos/redirectToVisitPage';

export const fetchPosOrderByVisitTrackId = ({ payload: visitTrackId }) =>
  sagaRoutineRequest(fetchPosOrderByVisitTrackIdRoutine, {
    request: () => call(Api.fetchPosOrderByVisitTrackId, visitTrackId),
    *failure(error) {
      yield put(setFetchPosOrderError(error));
    }
  });

export const createPosOrder = ({ payload: body }) =>
  sagaRoutineRequest(createPosOrderRoutine, {
    request: () => call(Api.createPosOrder, { body })
  });

export const completePosOrder = ({ payload: id }) =>
  sagaRoutineRequest(completePosOrderRoutine, {
    request: () => call(Api.completePosOrder, id),
    *success({ clientId }) {
      yield toastr.success('Success', 'Order Completed.');
      redirectToVisitPage(clientId);
    }
  });

export const cancelPosOrder = ({ payload: { id, isReturnItems } }) =>
  sagaRoutineRequest(cancelPosOrderRoutine, {
    request: () => call(Api.cancelPosOrder, { id, body: { isReturnItems } }),
    *success({ clientId }) {
      yield toastr.success('Success', 'Order Canceled.');
      redirectToVisitPage(clientId);
    }
  });

export const adjustPosOrder = ({ payload: { id, orderAdjustment } }) =>
  sagaRoutineRequest(adjustPosOrderRoutine, {
    request: () => {
      const body = orderAdjustmentToBodyFormat(orderAdjustment);
      return call(Api.adjustPosOrder, { id, body });
    },
    *success({ clientId }) {
      yield put(clearOrderAdjustment(id));
      yield toastr.success('Success', 'Order Adjusted.');
      redirectToVisitPage(clientId);
    }
  });

export const addPosOrderItem = ({ payload: { orderId, body } }) =>
  sagaRoutineRequest(addPosOrderItemRoutine, {
    request: () => call(Api.addPosOrderItem, { orderId, body })
  });

export const updatePosOrderItemQuantity = ({
  payload: { orderItem, quantity }
}) =>
  sagaRoutineRequest(updatePosOrderItemQuantityRoutine, {
    request: () => {
      const { posOrderId: orderId, id: itemId } = orderItem;
      return call(Api.updatePosOrderItem, {
        orderId,
        itemId,
        body: { quantity }
      });
    }
  });

export const deletePosOrderItem = ({ payload: orderItem }) =>
  sagaRoutineRequest(deletePosOrderItemRoutine, {
    request: () => {
      const { posOrderId: orderId, id: itemId } = orderItem;
      return call(Api.deletePosOrderItem, { orderId, itemId });
    },
    *success() {
      yield put(removeDeletedPosOrderItem(orderItem));
    }
  });

export const deletePosOrderItems = ({ payload: order }) =>
  sagaRoutineRequest(deletePosOrderItemRoutine, {
    request: () => call(Api.deletePosOrderItems, order.id),
    *success() {
      const { items, clientId } = order;
      yield all(
        map(orderItem => put(removeDeletedPosOrderItem(orderItem)), items)
      );
      redirectToVisitPage(clientId);
    }
  });
